module.exports = __webpack_public_path__ + "img/fig15.e39b299b.jpg";